module.exports = __webpack_public_path__ + "static/media/icone-fleche-droite.d5ce406c.svg";